import type { FaireProductEntity } from "../../entity_types/product";

export const p_rreq5j7w3z: FaireProductEntity = {
  token: "p_rreq5j7w3z",
  type: "product",
  name: "Salsa di Noci",
  brandToken: "b_dz40npc2du",
  brandName: "Olives Et Al",
  imageUrl:
    "https://cdn.faire.com/fastly/ba801e9de0f2249310f46bf9e2eeaf4488c83c67b692533d36f046b308049d1f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee4b3f5a7dcdf357a3b2a1742098b1a505f125f9bf47c352f96f92928a26fb8e.jpeg",
    "https://cdn.faire.com/fastly/1ff5b09fd908c7f92f6acbf6233c32bf13aa7a3cce4d4bd49474ee484a33bf07.jpeg",
    "https://cdn.faire.com/fastly/2ddd26893d9f56bd3a9c1e4f777a8d9abcfd04e035e566144a85c5c30d0ad099.jpeg",
  ],
  priceDollars: 4.39,
  description:
    "A wonderfully smooth walnut sauce made with walnuts, cashews, Parmesan and Extra Virgin Olive Oil. Velvety, savoury and deeply comforting.\n\nSmooth. Savoury. Comfortingly luxurious.\n\nA beautifully balanced Italian classic that proves simplicity, when done properly, is unbeatable.\n\nMade for us in Italy, this wonderfully smooth sauce brings together walnuts, Parmesan and Extra Virgin Olive Oil, blended slowly into something rich, velvety and deeply satisfying. A hint of marjoram adds a gentle herbal lift, rounding everything out without stealing the show.\n\nThe result? A sauce that’s creamy without cream, savoury without heaviness, and elegant without trying too hard. Nutty, mellow and quietly indulgent — the kind of flavour that grows on you with every bite.\n\nHow to enjoy it\nToss through hot pasta or gnocchi with a splash of the cooking water for instant comfort.\nDrizzle over roasted vegetables or grilled chicken for a smooth, savoury finish.\nSpread on toasted bread or flatbreads for an easy, crowd-pleasing snack.\nSwirl into soups or mashed potatoes for extra richness and depth.\nFor cosy dinners, unfussy entertaining, or whenever you want food that feels soothing, indulgent and just a little bit special.\n\nA northern Italian classic, done properly.\nVelvet in a jar.\n\n135g, 4.7oz",
  tags: [],
  msrpDollars: 7.35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:11.561Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
